import { signal } from "~/sdk/signal";
import Icon from "~/components/ui/Icon";
import MyAccount from "~/components/Header/Buttons/MyAccount";
import { useUser } from "~/hooks/useUser";

function MobileMenuAccountOptions() {
  const { user } = useUser();
  const isUserLoggedIn = Boolean(user.value?.email);

  return (
    <div className="flex justify-start flex-col items-start bg-[#FAFAFA] w-full border-t-[1px] border-solid border-[#F0F0F0]">
      <div className="flex items-center gap-2 w-full justify-star border-b-[1px] border-[#F0F0F0] py-5 px-5">
        <MyAccount isSearchVisible={signal(false)} />
      </div>

      <div className="flex items-center gap-1 w-full justify-start py-4 px-5">
        <Icon
          className="text-base-100"
          size={17}
          id="Package"
          strokeWidth={2}
        />
        <a
          className="font-['Poppins'] not-italic font-normal text-[15px] leading-[15px] tracking-[2%] text-black capitalize"
          href={isUserLoggedIn ? "/account#/orders" : "/login-user?returnUrl=%2Faccount%23%2Forders"}
        >
          meus pedidos
        </a>
      </div>
    </div>
  );
}

export default MobileMenuAccountOptions;
